import { IANAZone } from "luxon";

import { DateTime } from "../Types/DateTime";
import { Block } from "./Block";

/** A Slot from the Ops. */
export class Slot extends Block {
  id!: string;
  /** The UTC DateTime object for the block start time. */
  startTime?: string | DateTime;
  /** The UTC DateTime object for the block end time. */
  endTime?: string | DateTime;
  /** The start time key combined with date */
  startTimeKey?: string;
  /** The end time key combined with date */
  endTimeKey?: string;
}

/** A Slot from the Ops including advanced objects for local logic. */
export class EnhancedOpsSlot extends Slot {
  /** The UTC DateTime object for the block start time. */
  startTime: DateTime;
  /** The UTC DateTime object for the block end time. */
  endTime: DateTime;

  constructor(slot: Pick<Slot, "startTimeKey" | "endTimeKey" | "id" | "type">, zone: IANAZone) {
    super();

    const { name } = zone;
    const startTimeKey = DateTime.fromISO(slot.startTimeKey as string, { zone: name });
    const endTimeKey = DateTime.fromISO(slot.endTimeKey as string, { zone: name });

    this.id = slot.id;
    this.type = slot.type;
    this.startTimeKey = slot.startTimeKey;
    this.endTimeKey = slot.endTimeKey;
    this.startTimeUtc = startTimeKey.toUTC().toISO();
    this.endTimeUtc = endTimeKey.toUTC().toISO();
    this.startTime = startTimeKey;
    this.endTime = endTimeKey;
  }
}
